import ReactMarkdown from 'react-markdown';
import { Swiper, SwiperSlide } from 'swiper/react';

import { ArrowRightIcon } from 'modules/icons/ArrowRight';

import { Brand } from './Brand';
import * as S from './Hero.style';
import * as T from './Hero.types';

export const Hero: React.FC<T.HeroCasesCollection> = ({ description, items, title }) => {
  return (
    <S.BannerPrincipal className="section">
      <S.Container>
        <S.Left>
          <h1>{title}</h1>
          <ReactMarkdown>{description}</ReactMarkdown>
          <div className="contact">
            <S.Link
              onClick={() => {
                const newsletter = document.getElementById('footer');
                newsletter && newsletter.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}
            >
              Quero me inscrever
              <ArrowRightIcon />
            </S.Link>
          </div>
        </S.Left>
        <S.Right>
          <S.CasesPrincipais>
            <Swiper
              spaceBetween={0}
              slidesPerView={1}
              navigation
              pagination={false}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
            >
              {items.map((item) => {
                return (
                  <SwiperSlide className="marca" key={item.image.url}>
                    {({ isActive }) => (
                      <Brand
                        key={item.image.url}
                        brand={item}
                        active={isActive ? 'active' : 'disable'}
                      />
                    )}
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </S.CasesPrincipais>
        </S.Right>
      </S.Container>
    </S.BannerPrincipal>
  );
};
